const initialState = {
    str: ''
}

const medCertIssuedRed = (state = initialState, action) => {
    switch(action.type){
        case 'MEDCERT_ISSUED' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default medCertIssuedRed